import { useState } from 'react';
import { debounce } from 'lodash';
import useSWR from 'swr';
import { InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';

import Table from '@components/Table';
import { getTableFields } from './stockLevelsFields';
import { getOrganisationStockStatus, useStock } from '@services/stock';
import { useShop } from '@services/ShopProvider';

import styles from './StockLevels.module.scss';

const StockLevels = ({ barcode, shopId = null, fieldName = null }) => {
	const { data: stockItem } = useStock(barcode, shopId, { suspense: true });
	const { data: shops } = useShop();
	const [searchQuery, setSearchQuery] = useState('');
	const { data } = useSWR(`organisation-stock-status-${stockItem.barcode}`, () => getOrganisationStockStatus(stockItem.barcode), {
		suspense: true
	});

	const handleSearchChange = (e) => {
		const query = e.target.value;
		setSearchQuery(query);
	};

	const filteredShops = data
		.map((item) => {
			const shop = shops.find((shop) => shop.id === item.shopId);
			return {
				...item,
				name: shop.name
			};
		})
		.filter((item) => {
			if (searchQuery) {
				return item.name.toLowerCase().includes(searchQuery.toLowerCase());
			}
			return true;
		});

	return (
		<>
			<div className="search-bar-wrapper">
				<TextField
					variant="outlined"
					data-search-input
					className={styles.searchField}
					onChange={debounce(handleSearchChange, 50)}
					placeholder="Search for location..."
					InputProps={{
						className: styles.searchInput,
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon className={styles.searchFieldIcon} />
							</InputAdornment>
						)
					}}
				/>
			</div>
			<Table
				data={filteredShops}
				defaultSort={{
					orderBy: 'location',
					direction: 'asc',
					handler: (a, b) => a.name.localeCompare(b.name)
				}}
				fields={getTableFields(barcode, fieldName)}
			/>
		</>
	);
};

export default StockLevels;
